import {
  TemplateOutputs,
  TemplateSummaryOutputs,
} from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'
import { Box, Grid, Paper, styled } from '@mui/material'
import { ChartView } from 'Features/Projects/Scenarios/Templates/TemplateResults/Results/Results.ChartView'
import { SequencedGraphView } from 'Features/Projects/Scenarios/Templates/TemplateResults/Results/Results.SequencedGraphView'
import { TotalledGraphView } from 'Features/Projects/Scenarios/Templates/TemplateResults/Results/Results.TotalledGraphView'
import { PlanTemplateSummaryView } from 'Features/Projects/Scenarios/Templates/TemplateResults/Results/Results.PlanTemplateSummary.view'
import { Loader } from 'Common/Loader/Loader'

type ResultsViewProps = {
  templateOutputsData: TemplateOutputs[]
  templateSummaryData: TemplateSummaryOutputs[]
  isLoading: boolean
  width: number
  height: number
}

const Item = styled(Box)(({ theme }) => ({
  display: 'flex',
  shadow: theme.shadows[2],
  height: '100%',
  width: '100%',
  minWidth: '750px',
}))

export const ResultsView = ({
  templateSummaryData,
  templateOutputsData,
  isLoading,
  width,
  height,
}: ResultsViewProps) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          flex: 1,
          overflow: 'auto',
          paddingTop: 3,
        }}
        width={width}
        height="800px"
      >
        <Loader />
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        flex: 'auto',
        paddingTop: 3,
        height: '800px',
        minWidth: '1800px',
      }}
      width={width}
    >
      <Box display="flex" height="100%" width="100%" flexDirection="column">
        <Grid container spacing={1} sx={{ width: '100%', height: '100%' }}>
          <Grid size={6}>
            <Item>
              <ChartView
                SequencedGraphView={
                  <SequencedGraphView
                    templateOutputsData={templateOutputsData}
                    templateSummaryData={templateSummaryData}
                  />
                }
                TotalledGraphView={
                  <TotalledGraphView
                    templateOutputsData={templateOutputsData}
                    templateSummaryData={templateSummaryData}
                  />
                }
              />
            </Item>
          </Grid>
          <Grid size={6}>
            <Item>
              <PlanTemplateSummaryView
                templateSummaryData={templateSummaryData}
              />
            </Item>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
